import classnames from 'classnames'
import { LinkButton } from '@/components/common'
import { useTranslation } from 'react-i18next'

type ResetDataSetsButtonProps = {
    isHidden?: boolean
    onClick?: () => void
}

export const ResetReportSettingsButton: React.FC<ResetDataSetsButtonProps> = ({
    onClick,
    isHidden,
}) => {
    const { t } = useTranslation('translations')

    const wrapperClassname = classnames('transition-all', {
        'opacity-0 pointer-events-none': isHidden,
    })

    return (
        <div className={wrapperClassname}>
            <LinkButton
                iconBefore="sync"
                name="reset-data-sets-button"
                label={t('common.reset')}
                onClick={onClick}
            />
        </div>
    )
}
